import proptypes from 'prop-types';
import { Radio, FormControl, FormControlLabel, RadioGroup, Typography, Button, useMediaQuery, Grid, Select, MenuItem } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

function RadioFeature({ setValue, value = null }) {
  const { t } = useTranslation();
  const matches = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const valueChange = (newValue) => {
    setValue(newValue);
  };

  if (matches) {
    return (
      <FormControl fullWidth>
        <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
          <Select labelId="feature-select-label" id="feature-select" name="feature" value={value} onChange={(e) => valueChange(e.target.value)} sx={{ width: '50%', alignSelf: 'center' }}>
            <MenuItem value={null}>0</MenuItem>
            <MenuItem value={1}>1</MenuItem>
            <MenuItem value={2}>2</MenuItem>
            <MenuItem value={3}>3</MenuItem>
            <MenuItem value={4}>4</MenuItem>
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={6}>6</MenuItem>
            <MenuItem value={7}>7</MenuItem>
            <MenuItem value={8}>8</MenuItem>
            <MenuItem value={9}>9</MenuItem>
            <MenuItem value={10}>10</MenuItem>
          </Select>
          <Button onClick={() => valueChange(null)} sx={{ pb: 0 }} disabled={!value}>
            <ClearIcon data-testid="clear-icon" />
          </Button>
        </Grid>
      </FormControl>
    );
  }

  return (
    <RadioGroup row value={value} onChange={(e) => valueChange(e.target.value)}>
      <Typography sx={{ alignSelf: 'end', pb: '0.6em' }}>{t('common.word.veryBad')}</Typography>
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={1} label="1" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={2} label="2" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={3} label="3" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={4} label="4" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={5} label="5" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={6} label="6" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={7} label="7" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={8} label="8" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={9} label="9" labelPlacement="top" />
      <FormControlLabel sx={{ m: 0 }} control={<Radio />} value={10} label="10" labelPlacement="top" />
      <Typography sx={{ alignSelf: 'end', pb: '0.6em' }}>{t('common.word.veryGood')}</Typography>
      <Typography sx={{ alignSelf: 'end', pb: '0.6em', width: '0' }}>
        <Button onClick={() => valueChange(null)} sx={{ pb: 0 }} disabled={!value}>
          <ClearIcon data-testid="clear-icon" />
        </Button>
      </Typography>
    </RadioGroup>
  );
}

RadioFeature.propTypes = {
  setValue: proptypes.func.isRequired,
  value: proptypes.number,
};

export default RadioFeature;
